import { render, staticRenderFns } from "./validateIQIcon.vue?vue&type=template&id=04f2628f"
import script from "./validateIQIcon.vue?vue&type=script&lang=js"
export * from "./validateIQIcon.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports